import { Div, Label, P } from '@kizi/core-components';
import * as React from 'react';
import { withFormProps } from '../HOCs';
import { ModalAccordions } from '../ModalAccordion';
import { getCallGroup } from './getCallGroup';
import { getNetworkInformationGroup } from './getNetworkInformationGroup';
import { DisplayGroup } from './groupInterfaces';
import { getTelevisionGroup } from './getTelevisionGroup';
import { Services, useField } from '@kizi/comparator-core';

interface ProductPackageDetailsTripplePlayProps {
  content: Services;
  description: string;
  postcoderoosregeling?: string;
}

const LabelWithTooltip = withFormProps(Label);

const getGroup = (
  g: DisplayGroup,
): {
  label: JSX.Element;
  value?: JSX.Element | string | number;
  icon: string | undefined;
} => {
  return {
    label: (
      <LabelWithTooltip
        _containerProps={{
          variant: 'filterLabel', // Will adapt to smaller size
        }}
        _label={g.label}
        _tooltip={g.tooltip}
      />
    ),
    value: g.value,
    icon: g.icon,
  };
};

export const ProductPackageDetailsTripplePlay: React.FC<ProductPackageDetailsTripplePlayProps> =
  React.forwardRef<HTMLDivElement, ProductPackageDetailsTripplePlayProps>(
    (
      {
        content,
        description,
        ...restProps
      }: ProductPackageDetailsTripplePlayProps,
      ref,
    ) => {
      const { networkInformation, callInfo } = content;

      const filters = useField('filters');
      const filtersData = filters?.value
        ? JSON.parse(filters.value as string).productTypes
        : [];

      const networkInformationGroupFields =
        getNetworkInformationGroup(networkInformation).map(getGroup);
      const callInformationGroupFields = getCallGroup(callInfo).map(getGroup);
      const televisionGroupFields = getTelevisionGroup(content).map(getGroup);

      return (
        <Div {...restProps} ref={ref} variant="accordionContainer">
          <P variant="bodyRegular">{description}</P>

          <ModalAccordions
            collapseOnClick={false}
            groups={[
              ...(filtersData.includes('internet')
                ? [
                    {
                      mt: 3,
                      accordionInnerListVariant: 'accordionInnerList',
                      title: 'Internet',
                      fields: networkInformationGroupFields,
                    },
                  ]
                : []),
              ...(filtersData.includes('television')
                ? [
                    {
                      accordionInnerListVariant: 'accordionInnerList',
                      title: 'Televisie',
                      fields: televisionGroupFields,
                    },
                  ]
                : []),
              ...(filtersData.includes('call')
                ? [
                    {
                      accordionInnerListVariant: 'accordionInnerList',
                      title: 'Bellen',
                      fields: callInformationGroupFields,
                    },
                  ]
                : []),
            ]}
          />
        </Div>
      );
    },
  );
